<admin-app-header></admin-app-header>
<app-enterprise-admin-bar></app-enterprise-admin-bar>

<div class="subscriptions-page">
    <div class="container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <h1>Subscriptions</h1>
            <div class="page-header__actions">
                <a routerLink="/admin/subscriptions/create-on-behalf" class="btn btn-primary"><i class="fa-solid fa-credit-card"></i> Create on behalf of client</a>
                <a routerLink="/admin/subscriptions-manual/create" class="btn btn-primary"><i class="fa-solid fa-plus"></i> Create Manual</a>
                <button (click)="openColumnConfig()" class="btn btn-secondary"><i class="fa-solid fa-table-columns"></i> Columns</button>
                <button (click)="globalService.exportcsv('all-subscriptions')" class="btn btn-secondary"><i class="fa-solid fa-file-csv"></i> Export CSV</button>
            </div>
        </div>

        <!-- Summary Stats -->
        <div class="stats-grid">
            <div class="stat-card stat-card--green">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-circle-check"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Active</span>
                    <span class="stat-card__value">{{ getActiveCount() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--red">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-circle-xmark"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Cancelled</span>
                    <span class="stat-card__value">{{ getCancelledCount() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--blue">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-flag-checkered"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Completed</span>
                    <span class="stat-card__value">{{ getCompletedCount() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--purple">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-coins"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Monthly Revenue</span>
                    <span class="stat-card__value">R{{ getTotalMonthlyRevenue() | number: '1.0-0' }}</span>
                </div>
            </div>
        </div>

        <!-- Filter Bar -->
        <div class="filter-bar">
            <div class="filter-bar__left">
                <div class="status-toggle">
                    <button class="toggle-btn" [class.active]="currentStatusFilter === 'active'" (click)="setStatusFilter('active')"><i class="fa-solid fa-circle-check"></i> Active</button>
                    <button class="toggle-btn" [class.active]="currentStatusFilter === 'cancelled'" (click)="setStatusFilter('cancelled')"><i class="fa-solid fa-circle-xmark"></i> Cancelled</button>
                    <button class="toggle-btn" [class.active]="currentStatusFilter === 'completed'" (click)="setStatusFilter('completed')"><i class="fa-solid fa-flag-checkered"></i> Completed</button>
                </div>
                <div class="search-input">
                    <i class="fa-solid fa-search"></i>
                    <input type="text" (input)="searchKeydown($event)" placeholder="Search subscriptions..." />
                </div>
            </div>
            <div class="filter-bar__right">
                <span class="results-count">{{ filteredSubscriptions?.length || 0 }} results</span>
            </div>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="filteredSubscriptions && filteredSubscriptions.length === 0">
            <i class="fa-solid fa-file-contract"></i>
            <h3>No subscriptions found</h3>
            <p>There are no subscriptions matching your criteria.</p>
        </div>

        <!-- Subscriptions Table -->
        <div class="table-card" *ngIf="filteredSubscriptions && filteredSubscriptions.length > 0">
            <table class="subscriptions-table" id="all-subscriptions">
                <thead>
                    <tr>
                        <ng-container *ngFor="let column of columns">
                            <th
                                *ngIf="visibleColumns[column.key]"
                                [class.sortable]="column.sortable"
                                [class.sorted]="isColumnSorted(column.key)"
                                (click)="column.sortable ? sortByColumn(column.key) : null"
                            >
                                {{ column.label }}
                                <i *ngIf="column.sortable && column.key" [class]="getSortIcon(column.key)" class="sort-icon"></i>
                            </th>
                        </ng-container>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        *ngFor="let subscription of filteredSubscriptions"
                        (contextmenu)="showContextMenu($event, subscription)"
                        class="subscription-row"
                    >
                        <!-- Created -->
                        <td *ngIf="visibleColumns['createdAt']">
                            <span class="date-link">
                                {{ subscription.createdAt | formatDate }}
                            </span>
                        </td>

                        <!-- Status -->
                        <td *ngIf="visibleColumns['status']">
                            <span class="status-badge" [ngClass]="'status-badge--' + subscription.status?.toLowerCase()">
                                {{ subscription.statusNiceName }}
                            </span>
                            <span *ngIf="subscription.attempts" class="attempts-badge">
                                {{ subscription.attempts }}
                            </span>
                        </td>

                        <!-- Type -->
                        <td *ngIf="visibleColumns['type']">
                            <span class="type-badge" [ngClass]="'type-badge--' + subscription.type?.toLowerCase()">
                                {{ EnumNames.getSubscriptionType(subscription.type) }}
                            </span>
                        </td>

                        <!-- Term -->
                        <td *ngIf="visibleColumns['term']">
                            <span *ngIf="subscription.isMonthToMonth" class="badge text-white" style="background-color: #7A62A3; font-size: 0.75em">M2M</span>
                            <span *ngIf="!subscription.isMonthToMonth" class="badge text-white" style="background-color: #405C84; font-size: 0.75em">Fixed</span>
                            <span *ngIf="subscription.m2mCancellationPending" class="badge bg-warning text-dark ms-1" style="font-size: 0.65em">Cancelling</span>
                        </td>

                        <!-- Details -->
                        <td *ngIf="visibleColumns['details']">
                            <button class="details-btn" (click)="openSubscriptionDetail(subscription)">
                                <i class="fa-solid fa-arrow-up-right-from-square"></i> Details
                            </button>
                        </td>

                        <!-- Client -->
                        <td *ngIf="visibleColumns['clientRef']">
                            <a
                                *ngIf="subscription.clientRef"
                                [routerLink]="['/', AngularRoutes.client, subscription.clientRef.id]"
                                class="entity-link"
                                [class.undefined]="!subscription.denormClientFirstName"
                                [title]="getFullNameFromSubscription(subscription)"
                            >
                                {{ getFullNameFromSubscription(subscription) | truncate: [20] }}
                            </a>
                            <span *ngIf="!subscription.clientRef && subscription.manualClientName" class="manual-entry" title="Manual entry">
                                <i class="fa-solid fa-edit me-1"></i>{{ subscription.manualClientName | truncate: [20] }}
                            </span>
                            <span *ngIf="!subscription.clientRef && !subscription.manualClientName" class="missing-badge"> <i class="fa-solid fa-exclamation-triangle"></i> Missing </span>
                        </td>

                        <!-- Portfolio -->
                        <td *ngIf="visibleColumns['merchantRef']">
                            <a
                                *ngIf="subscription.merchantRef"
                                [routerLink]="['/', AngularRoutes.MERCHANT, subscription.merchantRef.id]"
                                class="entity-link"
                                [class.undefined]="!subscription.denormMerchantCompanyName"
                            >
                                {{ subscription.denormMerchantCompanyName || 'Undefined' | truncate: [25] }}
                            </a>
                            <span *ngIf="!subscription.merchantRef && subscription.manualMerchantName" class="manual-entry" title="Manual entry">
                                <i class="fa-solid fa-edit me-1"></i>{{ subscription.manualMerchantName | truncate: [25] }}
                            </span>
                            <span *ngIf="!subscription.merchantRef && !subscription.manualMerchantName" class="missing-badge"> <i class="fa-solid fa-exclamation-triangle"></i> Missing </span>
                        </td>

                        <!-- Parking -->
                        <td *ngIf="visibleColumns['parkingRef']">
                            <a
                                *ngIf="subscription.parkingRef"
                                [routerLink]="['/', AngularRoutes.parking, subscription.parkingRef.id]"
                                class="entity-link"
                                [class.undefined]="!subscription.denormParkingTitle"
                            >
                                {{ subscription.denormParkingTitle || 'Undefined' | truncate: [25] }}
                            </a>
                            <span *ngIf="!subscription.parkingRef && subscription.manualParkingName" class="manual-entry" title="Manual entry">
                                <i class="fa-solid fa-edit me-1"></i>{{ subscription.manualParkingName | truncate: [25] }}
                            </span>
                            <span *ngIf="!subscription.parkingRef && !subscription.manualParkingName" class="missing-badge"> <i class="fa-solid fa-exclamation-triangle"></i> Missing </span>
                        </td>

                        <!-- Bays -->
                        <td *ngIf="visibleColumns['baysBooked']">
                            <span class="count-badge" [class.count-badge--highlight]="subscription.baysBooked != 1"> <i class="fa-solid fa-car"></i> {{ subscription.baysBooked }} </span>
                        </td>

                        <!-- Start Date -->
                        <td *ngIf="visibleColumns['startDate']">
                            <span class="date-text">{{ subscription.startDate | customDate: 'D MMM YY' }}</span>
                        </td>

                        <!-- End Date -->
                        <td *ngIf="visibleColumns['endDate']">
                            <ng-container *ngIf="!subscription.isMonthToMonth">
                                <span class="date-text">{{ subscription.endDate | customDate: 'D MMM YY' }}</span>
                            </ng-container>
                            <ng-container *ngIf="subscription.isMonthToMonth">
                                <span class="text-muted">N/A</span>
                            </ng-container>
                        </td>

                        <!-- Duration -->
                        <td *ngIf="visibleColumns['period']">
                            <ng-container *ngIf="!subscription.isMonthToMonth">
                                <span class="count-badge" [class.count-badge--highlight]="subscription.period != 1"> {{ subscription.period }} {{ subscription.termNamePlural }} </span>
                            </ng-container>
                            <ng-container *ngIf="subscription.isMonthToMonth">
                                <span class="text-muted">Rolling</span>
                            </ng-container>
                        </td>

                        <!-- Monthly Fee -->
                        <td *ngIf="visibleColumns['periodFee']">
                            <span class="fee-text">R{{ subscription.periodFee | formatCents }}</span>
                        </td>

                        <!-- Total Subscription Value -->
                        <td *ngIf="visibleColumns['totalValue']">
                            <ng-container *ngIf="!subscription.isMonthToMonth">
                                <span class="fee-text fee-text--total">R{{ subscription.periodFee * subscription.period | formatCents }}</span>
                            </ng-container>
                            <ng-container *ngIf="subscription.isMonthToMonth">
                                <span class="fee-text fee-text--total">R{{ subscription.periodFee * (subscription.paymentsMade || 1) | formatCents }}</span>
                            </ng-container>
                        </td>

                        <!-- Invoice Due Date -->
                        <td *ngIf="visibleColumns['nextDebitDate']">
                            <span *ngIf="subscription.nextDebitDate && subscription.nextDebitDate.toDate().getTime() < today" class="due-badge due-badge--overdue">
                                {{ subscription.nextDebitDate | formatDate }}
                            </span>
                            <span *ngIf="!subscription.nextDebitDate || subscription.nextDebitDate.toDate().getTime() >= today" class="date-text">
                                {{ subscription.nextDebitDate | formatDate }}
                            </span>
                        </td>

                        <!-- Renewal Status -->
                        <td *ngIf="visibleColumns['renewalStatus']">
                            <span *ngIf="subscription.daysUntilExpiry" class="days-badge"> {{ subscription.daysUntilExpiry }}d </span>
                            <span *ngIf="subscription.renewalStatus" class="renewal-badge" [ngClass]="'renewal-badge--' + subscription.renewalStatus?.toLowerCase()">
                                {{ EnumNames.getRenewalStatus(subscription.renewalStatus) }}
                            </span>
                        </td>

                        <!-- Review Requested -->
                        <td *ngIf="visibleColumns['reviewRequested']">
                            <span *ngIf="subscription.reviewRequested" class="review-badge review-badge--sent" title="Review request sent"> true </span>
                            <span *ngIf="!subscription.reviewRequested" class="review-badge review-badge--pending" title="Review not requested"> false </span>
                        </td>

                        <!-- Source -->
                        <td *ngIf="visibleColumns['p_source']">
                            <span *ngIf="subscription.p_source" class="source-badge" (click)="$event.stopPropagation(); navigateToReporting(subscription.p_source, undefined)">
                                {{ subscription.p_source }}
                            </span>
                            <span *ngIf="!subscription.p_source" class="text-muted">—</span>
                        </td>

                        <!-- Campaign -->
                        <td *ngIf="visibleColumns['p_campaign']">
                            <span *ngIf="subscription.p_campaign" class="campaign-link" (click)="$event.stopPropagation(); navigateToReporting(subscription.p_source, subscription.p_campaign)">
                                {{ subscription.p_campaign | slice: 0:15 }}
                            </span>
                            <span *ngIf="!subscription.p_campaign" class="text-muted">—</span>
                        </td>

                        <!-- Admyt Tenant ID -->
                        <td *ngIf="visibleColumns['admytTenantId']">
                            <a *ngIf="subscription.admytTenantId" (click)="$event.stopPropagation(); openAdmytTenant(subscription)" class="admyt-link">
                                {{ subscription.admytTenantId | slice: 0:8 }}...
                            </a>
                            <span *ngIf="!subscription.admytTenantId" class="text-muted">—</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- Column Config Modal -->
<div class="modal-overlay" *ngIf="showColumnConfig" (click)="closeColumnConfig()">
    <div class="modal-card modal-card--config" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h2><i class="fa-solid fa-table-columns"></i> Configure Columns</h2>
            <button class="close-btn" (click)="closeColumnConfig()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <div class="modal-body">
            <div class="column-actions">
                <button class="column-action-btn" (click)="selectAllColumns()">Select All</button>
                <button class="column-action-btn" (click)="deselectAllColumns()">Deselect All</button>
            </div>
            <div class="column-grid">
                <label *ngFor="let col of columns" class="column-checkbox">
                    <input type="checkbox" [checked]="visibleColumns[col.key]" (change)="toggleColumn(col.key)" />
                    <span class="checkmark"></span>
                    <span class="column-label">{{ col.label }}</span>
                </label>
            </div>
        </div>
    </div>
</div>
